var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInviteFriend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 54,
    viewBox: "0 0 69 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.0073 22.13H60.1592V15.4939C60.1592 14.5814 59.3888 13.8348 58.4472 13.8348H55.0231C54.0815 13.8348 53.3111 14.5814 53.3111 15.4939V22.13H46.463C45.5214 22.13 44.751 22.8766 44.751 23.7891V27.1071C44.751 28.0196 45.5214 28.7662 46.463 28.7662H53.3111V35.4023C53.3111 36.3148 54.0815 37.0614 55.0231 37.0614H58.4472C59.3888 37.0614 60.1592 36.3148 60.1592 35.4023V28.7662H67.0073C67.9489 28.7662 68.7194 28.0196 68.7194 27.1071V23.7891C68.7194 22.8766 67.9489 22.13 67.0073 22.13ZM24.2067 27.1071C31.7717 27.1071 37.9029 21.1657 37.9029 13.8348C37.9029 6.50394 31.7717 0.5625 24.2067 0.5625C16.6416 0.5625 10.5104 6.50394 10.5104 13.8348C10.5104 21.1657 16.6416 27.1071 24.2067 27.1071ZM33.794 30.4252H32.0071C29.6316 31.4829 26.9887 32.0843 24.2067 32.0843C21.4246 32.0843 18.7924 31.4829 16.4062 30.4252H14.6193C6.67978 30.4252 0.238281 36.6674 0.238281 44.3612V48.6747C0.238281 51.4225 2.53882 53.6518 5.37436 53.6518H43.039C45.8745 53.6518 48.175 51.4225 48.175 48.6747V44.3612C48.175 36.6674 41.7335 30.4252 33.794 30.4252Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteFriend);
export default __webpack_public_path__ + "static/media/invite-friend.759b64546bbce5b433236504846f5e88.svg";
export { ForwardRef as ReactComponent };